module.exports = __webpack_public_path__ + "static/img/RSFUPS108_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSFUPS108_1.png
// module id = OsfP
// module chunks = 0